import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE = "gm_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE) || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(STORAGE, JSON.stringify(items)); }, [items]);

  // variant: { name, price, sku, availability, lead_time, image } opzionale
  const add = (product, qty = 1, variant = null) => {
    const key = `${product.id}|${variant?.name || ""}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        key,
        product_id: product.id,
        product_name: product.name,
        variant: variant?.name || "",
        sku: variant?.sku || product.sku || "",
        price: variant?.price ?? product.price,
        image: variant?.image || product.image,
        availability: variant?.availability || product.availability || "disponibile",
        lead_time: variant?.lead_time || product.lead_time || "",
        quantity: qty,
      }];
    });
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => (i.key || i.product_id) !== key));
  const setQty = (key, quantity) => setItems((prev) =>
    prev.map((i) => (i.key || i.product_id) === key ? { ...i, quantity: Math.max(1, quantity) } : i)
  );
  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
